export const DepartmentSvg = ({ props, active }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.25 20c0-1.52 1.23-2.75 2.75-2.75s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75S9.25 21.52 9.25 20zm4 0a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM17.25 20c0-1.52 1.23-2.75 2.75-2.75s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75-2.75-1.23-2.75-2.75zm4 0a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM1.25 20c0-1.52 1.23-2.75 2.75-2.75S6.75 18.48 6.75 20 5.52 22.75 4 22.75 1.25 21.52 1.25 20zm4 0a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM9.25 4c0-1.52 1.23-2.75 2.75-2.75S14.75 2.48 14.75 4 13.52 6.75 12 6.75 9.25 5.52 9.25 4zm4 0a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0z"
        fill={active ? '#FF6A00' : '#fff'}
      />
      <path
        d="M11.25 18V6c0-.41.34-.75.75-.75s.75.34.75.75v12c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
        fill={active ? '#FF6A00' : '#fff'}
      />
      <path
        d="M3.25 18v-4c0-2.42 1.33-3.75 3.75-3.75h10c2.42 0 3.75 1.33 3.75 3.75v4c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-4c0-1.58-.67-2.25-2.25-2.25H7c-1.58 0-2.25.67-2.25 2.25v4c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
        fill={active ? '#FF6A00' : '#fff'}
      />
    </svg>
  );
};
